import { useQuery } from '@tanstack/react-query';
import { getNewsList } from '../api/privilege';

export const useGetNewsList = (params) => {
  return useQuery({
    queryKey: ['newsList'],
    queryFn: ({ signal }) => getNewsList(params, signal),
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
  });
};
